import { Controller } from "@hotwired/stimulus"

export default class FormChangeController extends Controller {
  static targets = ["submit"]

  connect() {
    this.initialData = new FormData(this.element)
    this.disableButton()
    this.element.addEventListener("input", () => this.checkForChanges())
    this.element.addEventListener("change", () => this.checkForChanges())

    $(this.element).on('select2:select select2:unselect', (e) => {
      this.checkForChanges();
    })

    // check the input tags field
    this.element.querySelectorAll('input[data-controller*="tags-input"]').forEach((el) => {
      $(el).on('change', () => this.checkForChanges());
    });
  }

  checkForChanges() {
    const currentData = new FormData(this.element)
    for (let [key, value] of currentData.entries()) {
      if (value !== this.initialData.get(key)) {
        return this.enableButton()
      }
    }
    this.disableButton()
  }

  disableButton() {
    this.submitTarget.setAttribute("disabled", true)
    this.submitTarget.classList.add("opacity-50")
  }

  enableButton() {
    this.submitTarget.removeAttribute("disabled")
    this.submitTarget.classList.remove("opacity-50")
  }
}
